<template>
  <div id="mainHolder" v-if="lgdn.loggedIn">
    <div id="tops">
     <div class="lft"><strong>VND administracija</strong></div>
     <div class="rght">
      <div><router-link to="/dZpnOaCcAR/novi_artikal">Novi Artikal</router-link></div>
      <div><router-link to="/dZpnOaCcAR/artikli">Artikli</router-link></div>
      <div><router-link to="/dZpnOaCcAR/porudzbe">Porudžbe</router-link></div>
      <div><router-link to="/dZpnOaCcAR/pracenje">Praćenje</router-link></div>
     </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'Admin',
  components: {
  },
  computed: {
    lgdn () {
      return this.$store.getters.user
    }
  },
  created () {
    if (!this.lgdn.loggedIn) this.$router.replace({ name: 'Home' })
  }
}
</script>

<style lang="scss" scoped>
#mainHolder{
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

#tops{
  position: fixed;
  width: 100%;
  background-color: #eee;
  padding: 10px;
  height: 2.4vw;
  z-index: 99999999999;
}

.lft{
  position: absolute;
  left: 3vw;
}

.rght{
  position: absolute;
  right: 2vw;
  display: flex;
  a{
    padding: 0.5vw;
    margin: 0px 0.7vw;
  }
  .router-link-exact-active{
    background-color: #444;
    color: #fff;
  }
}

</style>
